export const API_URL = process.env.BLOGS_API_URL || "http://localhost:4000/api/v1";

/** Ingest-only Axiom token. Leave unset to disable frontend logging. */
export const AXIOM_TOKEN = process.env.BLOGS_AXIOM_TOKEN || "";

/** Axiom dataset for UI logs / web vitals. */
export const AXIOM_DATASET = process.env.BLOGS_AXIOM_DATASET || "";
